var MAX_PIC_SIZE = 800;

export default function resizeImage(file) {
  return new Promise(function (resolve) {
    var img = new Image();
    img.onload = function () {
      URL.revokeObjectURL(img.src);
      var w = img.width;
      var h = img.height;
      var scale = Math.max(w, h) > MAX_PIC_SIZE ? MAX_PIC_SIZE / Math.max(w, h) : 1;
      var nw = Math.round(w * scale);
      var nh = Math.round(h * scale);
      var canvas = document.createElement('canvas');
      canvas.width = nw;
      canvas.height = nh;
      canvas.getContext('2d').drawImage(img, 0, 0, nw, nh);
      canvas.toBlob(
        function (blob) {
          var resized = new File([blob], file.name.replace(/\.\w+$/, '.jpg'), {
            type: 'image/jpeg',
          });
          resolve(resized);
        },
        'image/jpeg',
        0.85
      );
    };
    img.src = URL.createObjectURL(file);
  });
}
